import * as React from 'react';
import styled from 'styled-components';
import { INotificationInfo, NotificationType } from '../notification-types';
import { IBaseComponentProps } from '../../types';
import { PrimaryButton, NegativeButton, PositiveButton, WarningButton } from '../../button';

interface INotificationItemActionButtonProps extends Pick<INotificationInfo, 'actionLabel'>, IBaseComponentProps {
    type: NotificationType;
    onClick?(): void;
}

function getButtonByType(type: NotificationType) {
    switch (type) {
        case 'error':
            return NegativeButton;
        case 'information':
            return PrimaryButton;
        case 'success':
            return PositiveButton;
        case 'warning':
            return WarningButton;
        default:
            return PrimaryButton;
    }
}

function NotificationItemActionButtonBase(props: INotificationItemActionButtonProps) {
    const { actionLabel = 'Action', onClick, className, type } = props;

    const buttonProps = React.useMemo(() => ({
        label: actionLabel,
        className: className,
        onClick
    }), [actionLabel, onClick, className]);

    const Button = getButtonByType(type);

    return (
        <Button {...buttonProps} />
    );
}

export const NotificationItemActionButton = styled(NotificationItemActionButtonBase).attrs(() => ({
    className: String('ap-notification-itemActionButton')
}))`
    display: inline-block;
    position: absolute;
    top: 35%;
    right: 50px;
    height: 30px;
`;
